import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DistributeParams } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const distribute = createAsyncThunk<
  void,
  DistributeParams,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.DISTRIBUTE, async (params, { extra }) => {
  await extra.batchesRepo.distribute(params);
});
